import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { treatExperiment } from '#src/app/shared/api/experiments';
import { isMobile } from '#src/app/shared/utils/userAgent';

import type { PsfPromoteOrShareDataQuery } from '../api.graphql';

type Experiment = PsfPromoteOrShareDataQuery['experiments']['promoteShareOnComboExperiment'];

type Params = {
	experiment: Experiment;
	utilityContext: UtilityContext;
};

export async function normalizePromoteShareOnComboExperiment({
	experiment,
	utilityContext,
}: Params): Promise<Experiment['variation']> {
	if (shouldRunExperiment({ experiment, utilityContext })) {
		await treatExperiment(utilityContext, experiment.experimentName);
		return experiment.variation;
	}

	return 'control';
}

function shouldRunExperiment({ experiment, utilityContext }: Params): boolean {
	return (
		experiment.experimentName !== '__invalid_experiment__' &&
		// The exclusion group can reject this experiment (enabledIf false) while experimentName still
		// resolves to the real name, so treating on name alone would still contaminate experiment-service.
		experiment.fallbackReason !== 'disabled' &&
		isMobile(utilityContext)
	);
}
